export default {
  items: [
    {
      title: true,
      name: 'Analytics',
      class: '',
      wrapper: {
        element: '',
        attributes: {}
      }
    },
    {
      name: 'Workspace Summary',
      url: '/dashboard',
      icon: 'icon-speedometer',
      badge: {
        variant: 'primary',
        text: null
      }
    },
    {
      name: 'Messaging',
      url: '/messaging',
      icon: 'icon-bubbles',
      badge: {
        variant: 'primary',
        text: null
      }
    },
    {
      name: 'Social',
      url: '/social',
      icon: 'icon-globe',
      badge: {
        variant: 'primary',
        text: null
      },
    },
    {
      name: 'Channel Details',
      url: '/details/channel',
      icon: 'icon-layers',
      badge: {
        variant: 'primary',
        text: null
      },
    },
    {
      name: 'Teammate Details',
      url: '/details/teammate',
      icon: 'icon-user',
      badge: {
        variant: 'primary',
        text: null
      },
    },
    


    {
      title: true,
      name: 'My Team',
      class: '',
      wrapper: {
        element: '',
        attributes: {}
      }
    },
    {
      name: 'User Groups',
      url: '/org/groups',
      icon: 'icon-people',
      badge: {
        variant: 'primary',
        text: null
      }
    },
    {
      name: 'Account',
      url: '/org/account',
      icon: 'icon-settings',
      badge: {
        variant: 'primary',
        text: null
      }
    },
  ]
}
